import React, { useEffect } from "react";
import Navigation from "../components/site/Navigation";
import Footer from "../components/site/Footer";

const TODAY = "May 23, 2026";

const Section = ({ title, children }) => (
  <section className="mb-12">
    <h2 className="font-serif text-2xl text-themed mb-4">{title}</h2>
    <div className="text-themed-muted leading-relaxed space-y-3 text-[15px]">
      {children}
    </div>
  </section>
);

const TermsPage = () => {
  useEffect(() => {
    document.title = "Terms of Service · Authentic Momentum";
  }, []);
  return (
    <>
      <Navigation />
      <main
        data-testid="terms-page"
        className="min-h-screen bg-themed text-themed pt-32 pb-24"
      >
        <article className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-gold mb-4">
            Agreements · Boundaries
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl text-themed mb-3 leading-tight">
            Terms of Service
          </h1>
          <p className="text-themed-muted/70 text-sm mb-10">Last updated: {TODAY}</p>

          <Section title="Acceptance">
            <p>
              By using authentic-momentum.com or purchasing any product or
              service from Authentic Momentum (operated by Cyrus Prescod under
              Damone &amp; Associates LLC), you agree to these terms.
            </p>
          </Section>

          <Section title="Products">
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Clarity Snapshot (Free).</strong> A short reflection tool that returns an archetype and brief synthesis. No deliverable beyond the on-screen result.</li>
              <li><strong>The Book. Authentic Momentum ($19.95).</strong> Sold on Amazon Kindle. Delivered directly through your Amazon account after purchase.</li>
              <li><strong>The Personal Action Plan ($49.99).</strong> A guided intake followed by an AI-assisted personalized draft delivered to your email.</li>
              <li><strong>Clarity Reset Session Session ($149).</strong> A scheduled 1:1 session. Booking is opened after payment confirmation.</li>
            </ul>
          </Section>

          <Section title="Refunds">
            <p>
              Because all products are digital and delivered immediately or
              shortly after purchase, we offer refunds case-by-case within 14
              days of purchase if the product has not been substantially used
              or delivered. Email us to request a refund.
            </p>
          </Section>

          <Section title="Intellectual property">
            <p>
              All copy, frameworks, methods, and the Personal Action Plan synthesis are the
              intellectual property of Cyrus Prescod and Authentic Momentum. You
              receive a personal, non-transferable license to use the deliverables.
              Resale, redistribution, or training of AI models on this content is
              not permitted.
            </p>
          </Section>

          <Section title="No professional advice">
            <p>
              Authentic Momentum is a personal-development and brand-strategy
              practice. Nothing on this site or in our deliverables constitutes
              medical, psychological, legal, or financial advice. You are
              responsible for your own decisions.
            </p>
          </Section>

          <Section title="Limitation of liability">
            <p>
              To the maximum extent permitted by law, Authentic Momentum is not
              liable for any indirect, incidental, or consequential damages
              arising from your use of the products or this site.
            </p>
          </Section>

          <Section title="Contact">
            <p>
              Cyrus Prescod · Authentic Momentum<br />
              <a className="text-gold hover:underline" href="tel:+19177228598">(917) 722-8598</a>
            </p>
          </Section>
        </article>
      </main>
      <Footer />
    </>
  );
};

export default TermsPage;
